module.exports = "* {\r\n  word-wrap: break-word;\r\n}\r\nhtml,body,h1,h2,h3,h4,h5 {font-family: \"Raleway\", sans-serif}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/header/header.component.css
// module id = ./src/app/admin/header/header.component.css
// module chunks = main